<soft-page>
  <soft-page-header>
    <div class="soft-title">
      {{ '#GOLDSCHMIEDE.DASHBOARD.HEADER.TITLE' | translate }}
    </div>
  </soft-page-header>

  @if (loading() === 'loaded') {
    @for (group of groupedAuftraege(); track group[0].kopfau.idkundenauftrag) {
      <div [ngClass]="{ group: group.length > 1 }" class="pointer">
        @for (
          auftrag of group;
          track auftrag.kopfau.id;
          let first = $first;
          let last = $last
        ) {
          <soft-dashboard-card
            [firstInGroup]="(group?.length ?? 0) > 1 && first"
            [lastInGroup]="group.length > 1 && last"
            [highlighted]="highlightedItem()?.id === auftrag?.kopfau?.idkundenauftrag"
            [auftrag]="auftrag"
            [saving]="saving()"
            (statusChanged)="onStatusChanged(auftrag?.kopfau, $event)"
            (detailPressed)="onDetailPressed(auftrag?.kopfau)"
          >
          </soft-dashboard-card>
        }
      </div>
    } @empty {
      <div class="c row center no-wrap min-height-75">
        <span class="soft-text color-light">
          {{ '#GOLDSCHMIEDE.DASHBOARD.EMPTY' | translate }}
        </span>
      </div>
    }
  } @else {
    <div class="flex flex-col w-full soft-card rounded-sm gap-3 mt-3" *softRepeat="2">
      <div class="h-3 w-10 skeleton"></div>
      <div class="h-3 w-20 skeleton" *softRepeat="2"></div>
    </div>
  }
</soft-page>
